import React from 'react';

import ModifierGroup from '../modifiers/ModifierGroup';

const MenuModalModifiers = ({
  modifiers,
  selection,
  handleSelectRadio,
  handleToggleCheckbox,
  handleSetQuantity,
}) => (
  <div className="item__modal__modifiers">
    {modifiers.map((modifier) => (
      <ModifierGroup
        key={modifier.modifierId}
        modifier={modifier}
        groupKey={modifier.modifierId}
        selection={selection}
        handleSelectRadio={handleSelectRadio}
        handleToggleCheckbox={handleToggleCheckbox}
        handleSetQuantity={handleSetQuantity}
      />
    ))}
  </div>
);

export default MenuModalModifiers;
